import { Tenant } from './model';
import { TenantDTO } from '../interface/apiModels';

export const convertTenantDTO = (tenantDTO: TenantDTO): Tenant => {
  return {
    ...tenantDTO,
    startTimestamp: new Date(tenantDTO.startTimestamp),
    createdAt: new Date(tenantDTO.createdAt),
  };
};
